/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindAllScreenerLeadWaitlistResponse } from './FindAllScreenerLeadWaitlistResponse';
import {
    FindAllScreenerLeadWaitlistResponseFromJSON,
    FindAllScreenerLeadWaitlistResponseFromJSONTyped,
    FindAllScreenerLeadWaitlistResponseToJSON,
    FindAllScreenerLeadWaitlistResponseToJSONTyped,
} from './FindAllScreenerLeadWaitlistResponse';

/**
 * 
 * @export
 * @interface FindAllScreenerLeadWaitlist200Response
 */
export interface FindAllScreenerLeadWaitlist200Response {
    /**
     * 
     */
    data?: FindAllScreenerLeadWaitlistResponse;
}

/**
 * Check if a given object implements the FindAllScreenerLeadWaitlist200Response interface.
 */
export function instanceOfFindAllScreenerLeadWaitlist200Response(value: object): value is FindAllScreenerLeadWaitlist200Response {
    return true;
}

export function FindAllScreenerLeadWaitlist200ResponseFromJSON(json: any): FindAllScreenerLeadWaitlist200Response {
    return FindAllScreenerLeadWaitlist200ResponseFromJSONTyped(json, false);
}

export function FindAllScreenerLeadWaitlist200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllScreenerLeadWaitlist200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : FindAllScreenerLeadWaitlistResponseFromJSON(json['data']),
    };
}

export function FindAllScreenerLeadWaitlist200ResponseToJSON(json: any): FindAllScreenerLeadWaitlist200Response {
    return FindAllScreenerLeadWaitlist200ResponseToJSONTyped(json, false);
}

export function FindAllScreenerLeadWaitlist200ResponseToJSONTyped(value?: FindAllScreenerLeadWaitlist200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': FindAllScreenerLeadWaitlistResponseToJSON(value['data']),
    };
}

